import { c as _c } from "react/compiler-runtime";
import trackCustomerActions, { CustomerActionsType } from '@spa/lib/tracking/trackCustomerActions';
import { SessionsData } from '@spa/lib/auth/sessionTypes';
import getAuthSessionUserId from '@spa/lib/auth/getAuthSessionUserId';
import { useCallback } from 'react';
import useNextAuthOrSession from '@spa/lib/react/hooks/useNextAuthOrSession';
export interface UseNewsletterTrackingResult {
  readonly trackNewsletterDoubleOptIn: () => void;
  readonly trackNewsletterRegistration: () => void;
}
const useNewsletterTracking = () => {
  const $ = _c(11);
  const {
    authSession,
    session
  } = useNextAuthOrSession();
  let t0;
  if ($[0] !== authSession) {
    t0 = getAuthSessionUserId(authSession);
    $[0] = authSession;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const userId = t0;
  const anonymousUserId = session.guid;
  let t1;
  if ($[2] !== anonymousUserId || $[3] !== userId) {
    t1 = () => {
      trackCustomerActions({
        type: CustomerActionsType.NEWSLETTER_DOI
      }, anonymousUserId, userId);
    };
    $[2] = anonymousUserId;
    $[3] = userId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const trackNewsletterDoubleOptIn = t1;
  let t2;
  if ($[5] !== anonymousUserId || $[6] !== userId) {
    t2 = () => {
      trackCustomerActions({
        type: CustomerActionsType.NEWSLETTER_REGISTRATION
      }, anonymousUserId, userId);
    };
    $[5] = anonymousUserId;
    $[6] = userId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const trackNewsletterRegistration = t2;
  let t3;
  if ($[8] !== trackNewsletterDoubleOptIn || $[9] !== trackNewsletterRegistration) {
    t3 = {
      trackNewsletterDoubleOptIn,
      trackNewsletterRegistration
    };
    $[8] = trackNewsletterDoubleOptIn;
    $[9] = trackNewsletterRegistration;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default useNewsletterTracking;